import { siteInfo } from '@/mocks/articles';

interface Article {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  date: string;
  category: string;
}

interface BreadcrumbItem {
  name: string;
  url: string;
}

const categoryNameMap: Record<string, string> = {
  all: '全部',
  celebrity: '明星黑料',
  influencer: '网红内幕',
  kol: '大V爆料',
  society: '社会热点',
  entertainment: '娱乐圈',
};

export function generateOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: `https://${siteInfo.domain}`,
    description: siteInfo.description,
    email: siteInfo.email,
    telephone: siteInfo.phone,
    address: {
      '@type': 'PostalAddress',
      addressLocality: '广州',
      addressRegion: '广东',
      addressCountry: 'CN',
      streetAddress: '珠江新城华夏路91号',
    },
    foundingDate: siteInfo.foundingDate,
  };
}

export function generateWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    alternateName: '黑料91',
    url: `https://${siteInfo.domain}`,
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `https://${siteInfo.domain}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };
}

export function generateWebPageSchema(title: string, description: string, url: string, breadcrumbs: BreadcrumbItem[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description: description,
    url: url,
    breadcrumb: generateBreadcrumbSchema(breadcrumbs),
    isPartOf: {
      '@type': 'WebSite',
      name: siteInfo.name,
      url: `https://${siteInfo.domain}`,
    },
  };
}

export function generateBreadcrumbSchema(items: BreadcrumbItem[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function generateArticleSchema(article: Article, url: string, imageUrl: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    datePublished: article.date,
    dateModified: article.date,
    image: imageUrl,
    url: url,
    author: {
      '@type': 'Organization',
      name: siteInfo.name,
    },
    publisher: {
      '@type': 'Organization',
      name: siteInfo.name,
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    about: {
      '@type': 'Thing',
      name: categoryNameMap[article.category] || article.category,
    },
  };
}

export function generateFAQPageSchema(faqs: { question: string; answer: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}